export const autoLossScenarioMappings = {
  multivehicle: 'Collision with other vehicles',
  otherrearended: 'Another vehicle rear-ended me',
  irearended: 'I rear ended another vehicle',
  otherchangedlanes: 'Another vehicle changed lanes into me',
  ichangedlanes: 'I changed lanes into another vehicle',
  otherturnedleft: 'Another vehicle turned left in front of me',
  iturnedleft: 'I turned left in front of another vehicle',
  otherbacked: 'Another vehicle backed into me',
  ibacked: 'I backed into another vehicle',
  istruckparked: 'I struck another parked vehicle',
  otherstruckparked: 'My vehicle was struck while parked',
  other: 'Other',

  singlevehicle: 'Collision with something else',
  animalcollision: 'Collision with animal',
  pedestriancollision: 'Collision with pedestrian',
  cyclistcollision: 'Collision with cyclist',
  objectcollision: 'Collision with object/the ground',

  weatherevent: 'Weather event',
  flooding: 'Flood',
  wind: 'Wind',
  hail: 'Hail',
  partialfire: 'Fire',
  lightning: 'Lightning',

  crime: 'Crime against vehicle',
  theft: 'Theft',
  attemptedtheft: 'Attempted theft',
  vandalism: 'Vandalism',

  random: 'Random event',
  flyingfallingobjects: 'Flying or falling object',
  explosion: 'Explosion',

  injuryonly: 'Injury only',
  tpoccupant: 'Occupant of another vehicle',
  cyclistpedestrianinjury: 'Injured as a pedestrian or cyclist',
};

export const propLossScenarioMappings = {
  firedamage: 'Damage due to fire',
  waterdamage: 'Damage due to water',
  windhaildamage: 'Damage due to wind or hail',
  theftmissingitem: 'Theft or missing item',
  somethingelse: 'Something else',
};

export const autoLossScenarioMappingsFR = {
  multivehicle: 'Collision avec un ou plusieurs véhicules',
  otherrearended: 'Un autre véhicule m’a frappé par l’arrière',
  irearended: 'J’ai frappé un autre véhicule par l’arrière',
  otherchangedlanes: 'AUn autre véhicule a changé de voie et m’a frappé',
  ichangedlanes: 'J’ai changé de voie et j’ai frappé un autre véhicule',
  otherturnedleft: 'Un autre véhicule a tourné à gauche devant moi',
  iturnedleft: 'J’ai tourné à gauche devant un autre véhicule',
  otherbacked: 'Un autre véhicule a reculé et m’a frappé',
  ibacked: 'J’ai reculé et frappé un autre véhicule',
  istruckparked: 'J’ai frappé un véhicule stationné',
  otherstruckparked: 'Mon véhicule stationné a été frappé',
  other: 'Autre',

  singlevehicle: 'Collision avec autre chose',
  animalcollision: 'Collision avec un animal',
  pedestriancollision: 'Collision avec un piéton',
  cyclistcollision: 'Collision avec un cycliste',
  objectcollision: 'Collision avec un objet/le sol',

  weatherevent: 'Événement météorologique',
  flooding: 'Inondation',
  wind: 'Vent',
  hail: 'Grêle',
  partialfire: 'Feu',
  lightning: 'Foudre',

  crime: 'Crime contre mon véhicule',
  theft: 'Vol',
  attemptedtheft: 'Tentative de vol',
  vandalism: 'Vandalisme',

  random: 'Autre événement',
  flyingfallingobjects: 'Objet volant ou chute d’objet',
  explosion: 'Explosion',

  injuryonly: 'Blessures seulement',
  tpoccupant: 'Je suis le passager d’un autre véhicule',
  cyclistpedestrianinjury: 'Je suis un piéton ou cycliste blessé',
};

export const propLossScenarioMappingsFR = {
  firedamage: 'Dommages causés par un feu',
  waterdamage: 'Dommages causés par l’eau',
  windhaildamage: 'Dommages causés par le vent ou la grêle',
  theftmissingitem: 'Vol ou objet manquant',
  somethingelse: 'Autre',
};
